import React, { useState } from "react";
import { toast } from "react-toastify";
import { CallWithAuth } from "../../action/apiActions";
import { CHANGE_PASSWORD_API_URL } from "../../action/apiPath";
import { errorMessageCreate } from "../../util/custom";
import { showToast } from "../../util/toastHelper";
import Loading from "react-fullscreen-loading";
import { Link, useNavigate } from "react-router-dom";

const ChangePasswordPage = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const handleChangePassword = async () => {
        if (!oldPassword.trim()) {
            toast.error("Old password is required", {
                autoClose: 2000,
                position: "bottom-right",
            });
            return;
        }

        if (!newPassword.trim()) {
            toast.error("New password is required", {
                autoClose: 2000,
                position: "bottom-right",
            });
            return;
        }

        if (!confirmPassword.trim()) {
            toast.error("Confirm password is required", {
                autoClose: 2000,
                position: "bottom-right",
            });
            return;
        }

        if (newPassword.trim() && confirmPassword.trim() && newPassword.trim() != confirmPassword.trim()) {
            toast.error("Confirm password does not match", {
                autoClose: 2000,
                position: "bottom-right",
            });
            return;
        }

        try {
            setIsLoading(true);

            const response = await CallWithAuth(
                "POST",
                `${CHANGE_PASSWORD_API_URL}`,
                { oldPassword, newPassword }
            );
            const message = errorMessageCreate(response?.res?.data?.message);

            if (response?.res?.data?.statusCode === 200) {
                setOldPassword('');
                setNewPassword('');
                setConfirmPassword('');
                showToast("success", message);
                if (localStorage.getItem('role') == 'admin') {
                    navigate("/")
                } else {
                    navigate("/create-account")
                }
            } else {
                showToast("error", message);
            }
        } catch (err) {
            showToast("error", "Failed to change password.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div>
            {isLoading && (
                <Loading
                    loading
                    background="rgba(236, 240, 241, 0.7)"
                    loaderColor="#3498db"
                />
            )}
            <section className="create_account_block">
                <div className="site_container">
                    <div className="create_account_form mt-2">
                        <div className="heading_block">
                            <h1>Change Your Password</h1>
                        </div>
                        <div className="field_block">
                            <label htmlFor="oldPassword">Old Password</label>
                            <input
                                type="password"
                                id="oldPassword"
                                name="oldPassword"
                                className="text_field"
                                value={oldPassword}
                                onChange={(e) => setOldPassword(e.target.value)}
                            />
                        </div>
                        <div className="field_block">
                            <label htmlFor="newPassword">New Password</label>
                            <input
                                type="password"
                                id="newPassword"
                                name="newPassword"
                                className="text_field"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                            />
                        </div>
                        <div className="field_block">
                            <label htmlFor="confirmPassword">Confirm Password</label>
                            <input
                                type="password"
                                id="confirmPassword"
                                name="confirmPassword"
                                className="text_field"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                            />
                        </div>
                        <div class="btn_row">
                            <Link to={"/"} class="outlined_cta cta_outline cta_with_icon">
                                <span>Back</span>{" "}
                            </Link>
                            <button onClick={handleChangePassword} class="solid_cta cta_primary cta_with_icon">
                                <span>Update</span>
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default ChangePasswordPage;